// extracted by mini-css-extract-plugin
export var errorIcon = "_m1-1";
export var nameLogo = "_m1-0";